module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "Logout.9b0f5fc5.png";